var _path, _path2, _rect, _path3, _path4, _path5, _path6, _polygon, _polygon2, _circle, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _circle2, _path16, _path17, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _circle3, _circle4, _path18;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b445ccda-90ce-4f31-a390-0b1031309e06",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 888,
    height: 769.42842,
    viewBox: "0 0 888 769.42842",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "proud_self") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M205.23105,824.37209S190.82909,797.78892,156,809.28363Z",
    transform: "translate(-156 -65.28579)",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M206.09945,823.72248s-17.81085-22.63935,7.8964-50.88226Z",
    transform: "translate(-156 -65.28579)",
    fill: "#e6e6e6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 757.41185,
    width: 888,
    height: 2,
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M829.87192,578.32829l19.22716,74.77229s.71212,52.69667,4.98482,73.34807,18.515,70.49959,18.515,70.49959l17.09081,2.84847-3.56058-69.78748s0-42.01491-3.56059-51.27243-10.68175-103.9691-10.68175-103.9691Z",
    transform: "translate(-156 -65.28579)",
    fill: "#fbbebe"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M828.87192,573.32829l19.22716,74.77229s.71212,52.69667,4.98482,73.34807,18.515,70.49959,18.515,70.49959l17.09081,2.84847-3.56058-69.78748s0-42.01491-3.56059-51.27243-10.68175-103.9691-10.68175-103.9691Z",
    transform: "translate(-156 -65.28579)",
    opacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M883.17876,264.92844h-.00006c-23.737,0-42.97956,21.35506-42.97956,47.69786v33.46881h10.29347l5.95933-12.40046-1.48985,12.40046h66.16248l5.41758-11.27315-1.35438,11.27315H932.637v-26.279C932.637,289.50251,910.49376,264.92844,883.17876,264.92844Z",
    transform: "translate(-156 -65.28579)",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M811.71293,566.57836s-8.5454,36.318,2.84847,39.87855,8.5454-39.87855,8.5454-39.87855Z",
    transform: "translate(-156 -65.28579)",
    fill: "#fbbebe"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "669.955 316.854 664.258 323.263 665.683 446.46 652.864 504.853 681.349 507.702 695.591 390.202 691.319 330.384 669.955 316.854",
    fill: "#d0cde1"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "669.697 316.854 664 323.263 665.424 446.46 652.606 504.853 681.091 507.702 695.333 390.202 691.06 330.384 669.697 316.854",
    opacity: 0.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 723.37605,
    cy: 245.53549,
    r: 30.5971,
    fill: "#fbbebe"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M861.83371,329.17954s8.97515,46.50759,4.89554,51.40312,43.2439-8.97515,43.2439-8.97515-15.50253-31.821-7.34331-49.77128Z",
    transform: "translate(-156 -65.28579)",
    fill: "#fbbebe"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M939.18189,533.10885s8.54541,36.318-2.84847,39.87856-8.5454-39.87856-8.5454-39.87856Z",
    transform: "translate(-156 -65.28579)",
    fill: "#fbbebe"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M873.31106,569.78288s-12.106,72.63595-11.39387,83.3177,0,12.106,0,12.106-12.106,31.33316-15.66658,49.13608-11.39387,40.59068-11.39387,40.59068-9.25753,20.6514-1.42424,20.6514,18.515-2.84847,18.515-2.84847a36.36659,36.36659,0,0,1,7.83329-22.6713c8.5454-10.79821,34.18162-61.35852,34.18162-67.76757s4.2727-24.9241,4.2727-24.9241l16.37869-79.045Z",
    transform: "translate(-156 -65.28579)",
    fill: "#fbbebe"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M823.46286,521.35892s-12.106,61.24207-1.42423,62.66631,25.63621-9.25753,44.86338,2.84846,51.27243,9.25753,51.27243,9.25753,22.07563-56.25725,2.13635-69.78748S823.46286,521.35892,823.46286,521.35892Z",
    transform: "translate(-156 -65.28579)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M836.99309,767.03932a18.96893,18.96893,0,0,1,9.96964-1.42423,13.00477,13.00477,0,0,0,9.25752-2.13636s-5.69694,20.6514-4.98482,28.48469-2.13635,41.30279-17.09081,37.74221-19.22716-14.24235-13.53023-32.75739,4.27271-39.87856,4.27271-39.87856,10.39292-10.735,12.31763-9.28416S836.99309,767.03932,836.99309,767.03932Z",
    transform: "translate(-156 -65.28579)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M884.70493,793.38765s-7.12117-15.66657-15.66657-1.42423-9.25752,17.80293-9.25752,17.80293-24.212,22.07563-7.12118,24.212,30.621-.71212,30.621-4.2727,8.5454-2.84847,9.25752-5.69694-1.42423-29.1968-1.42423-29.1968Z",
    transform: "translate(-156 -65.28579)",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M900.72758,352.94322h0s-29.90892,5.69693-33.4695,4.98482a17.67468,17.67468,0,0,0-2.42731-.25741A35.98843,35.98843,0,0,0,844.95339,362.6c-9.91657,5.76037-24.69505,16.01194-24.69505,25.94907,0,14.95446,19.22716,40.59068,19.22716,40.59068s-17.80293,61.24207-16.3787,66.939-10.68175,24.9241-2.84846,31.33316,82.60558,0,96.1358,6.409,7.12118-85.454,7.12118-85.454,36.318-83.3177,17.80292-91.151c-5.99113-2.53471-11.16208-4.47292-15.41633-5.93527A32.58858,32.58858,0,0,0,900.72758,352.94322Z",
    transform: "translate(-156 -65.28579)",
    fill: "#d0cde1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M928.50014,357.92805l16.33992,2.7003S952,367.89769,952,371.45827s-1.42423,157.37788-3.56059,162.3627-25.63621,2.84847-25.63621,2.84847l4.2727-87.59041Z",
    transform: "translate(-156 -65.28579)",
    fill: "#d0cde1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M895.39707,278.06762a22.54075,22.54075,0,0,0-17.78531-9.076H876.768c-16.26936,0-29.45821,14.72189-29.45821,32.88229v.00007h5.45143l.8804-6.70123,1.29083,6.70123h32.33213l2.70882-5.66937-.67722,5.66937h6.36065q4.45215,22.11055-12.794,44.22111H893.698l5.41758-11.33875-1.35438,11.33875h20.65458l4.0632-26.07918C922.479,300.485,911.13093,283.92323,895.39707,278.06762Z",
    transform: "translate(-156 -65.28579)",
    fill: "#2f2e41"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 745.3356,
    cy: 199.43012,
    r: 16.09784,
    fill: "#2f2e41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M719.68725,245.52921h-4.16748V131.36247A66.0766,66.0766,0,0,0,649.443,65.28579H407.56544a66.07661,66.07661,0,0,0-66.07681,66.07668V757.69009a66.07661,66.07661,0,0,0,66.07681,66.07668H649.443a66.0766,66.0766,0,0,0,66.0768-66.07668V326.795h4.16748Z",
    transform: "translate(-156 -65.28579)",
    fill: "#3f3d56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M652.10921,82.47665h-31.573a23.44384,23.44384,0,0,1-21.70579,32.298H460.26173a23.44384,23.44384,0,0,1-21.70578-32.298H409.06667a49.34527,49.34527,0,0,0-49.34534,49.34522V757.23063a49.34529,49.34529,0,0,0,49.34534,49.34528H652.10921a49.3453,49.3453,0,0,0,49.34535-49.34528V131.82187A49.34528,49.34528,0,0,0,652.10921,82.47665Z",
    transform: "translate(-156 -65.28579)",
    opacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 594.72404,
    y: 490.14852,
    width: 46.82432,
    height: 11.27252,
    transform: "translate(1080.27241 926.28378) rotate(-180)",
    fill: "#6c63ff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 432.57316,
    y: 490.14852,
    width: 16.47522,
    height: 11.27252,
    transform: "translate(725.62155 926.28378) rotate(-180)",
    fill: "#6c63ff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 399.62272,
    y: 490.14852,
    width: 16.47522,
    height: 11.27252,
    transform: "translate(659.72066 926.28378) rotate(-180)",
    fill: "#6c63ff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 466.39073,
    y: 490.14852,
    width: 111.85809,
    height: 11.27252,
    transform: "translate(888.63955 926.28378) rotate(-180)",
    fill: "#6c63ff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 491.53712,
    y: 562.98635,
    width: 16.47522,
    height: 11.27252,
    transform: "translate(843.54946 1071.95943) rotate(-180)",
    fill: "#6c63ff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 458.58667,
    y: 562.98635,
    width: 16.47522,
    height: 11.27252,
    transform: "translate(777.64857 1071.95943) rotate(-180)",
    fill: "#6c63ff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 525.35468,
    y: 562.98635,
    width: 111.85809,
    height: 11.27252,
    transform: "translate(1006.56746 1071.95943) rotate(-180)",
    fill: "#6c63ff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 460.32091,
    y: 515.29492,
    width: 46.82432,
    height: 11.27252,
    transform: "translate(811.46614 976.57656) rotate(-180)",
    fill: "#6c63ff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 397.02137,
    y: 515.29492,
    width: 46.82432,
    height: 11.27252,
    transform: "translate(684.86705 976.57656) rotate(-180)",
    fill: "#6c63ff"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 651.08665,
    y: 515.29492,
    width: 16.47522,
    height: 11.27252,
    transform: "translate(1162.64852 976.57656) rotate(-180)",
    fill: "#6c63ff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 522.75333,
    y: 515.29492,
    width: 111.85809,
    height: 11.27252,
    transform: "translate(1001.36476 976.57656) rotate(-180)",
    fill: "#6c63ff"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 401.43801,
    y: 474.2884,
    width: 46.82432,
    height: 11.27252,
    fill: "#6c63ff"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 464.73756,
    y: 474.2884,
    width: 46.82432,
    height: 11.27252,
    fill: "#6c63ff"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 241.02137,
    y: 474.2884,
    width: 16.47522,
    height: 11.27252,
    fill: "#6c63ff"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 273.97181,
    y: 474.2884,
    width: 111.85809,
    height: 11.27252,
    fill: "#6c63ff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 374.77344,
    cy: 240.56197,
    r: 89.47009,
    fill: "#6c63ff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 368.38272,
    cy: 243.75733,
    r: 28.75824,
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M525.25679,310.76468c-1.78934-2.75412-.88507-6.49892-2.13992-9.53409-1.97051-4.76617-8.0947-5.88271-13.23379-6.31757a39.44537,39.44537,0,0,0-10.25356.02744,9.84114,9.84114,0,0,0-7.11128,5.15594c-.76034,1.52487-.56847-3.25281-.08138-9.38588a29.64587,29.64587,0,0,1,22.73586-26.52212q.10891-.02559.21586-.05027c6.257-1.44342,12.7086-2.50565,19.08605-1.75642s12.73421,3.5022,16.71428,8.54129c1.81907,2.30308,3.10534,5.01894,5.136,7.13785,3.56778,3.72291,8.85693,5.07759,13.71544,6.805,5.49473,1.95361,10.83631,4.63358,15.039,8.67659s7.18163,9.58322,7.26964,15.41425c.10265,6.80181-4.22413,13.82131-11.19609,15.16233a7.82742,7.82742,0,0,0-3.34329,1.44279c-6.65713,5.16169.93691,10.56508.88428,16.376-.04392,4.84878-5.44177,8.009-10.28547,8.235A19.51578,19.51578,0,0,1,548.971,334.73115c-.7302-3.97923-.16634-8.06621.30871-12.0839.54378-4.599-9.36031-15.42819-2.81794-7.49069a11.38347,11.38347,0,0,1,2.50128,5.26665c1.08888,6.34106-4.68154,8.474-8.32041,11.98758a15.07793,15.07793,0,0,0-3.64985,15.5201,17.38325,17.38325,0,0,1-3.15935-21.95171c1.17219-1.79771,2.68244-3.36167,3.794-5.19747,1.73452-2.86459,2.21286-9.09531-2.642-8.92421C531.52012,311.97963,527.92047,314.86456,525.25679,310.76468Z",
    transform: "translate(-156 -65.28579)",
    fill: "#2f2e41"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.703f28b6.svg";
export { ForwardRef as ReactComponent };